import ImagesCarouselSection from '../components/imagesCarouselSection'

class ImagesCarouselSections {
	components: ImagesCarouselSection[] = []

	init(container: Document | HTMLElement = document) {
		container.querySelectorAll<HTMLElement>('.hg-images-carousel').forEach((el) => {
			const component = new ImagesCarouselSection(el)
			component.init()
			this.components.push(component)
		})
	}

	update(container: Document | HTMLElement = document) {
		this.cleanup()
		this.init(container)
	}

	cleanup() {
		this.components.forEach((c) => c.cleanup())
		this.components = []
	}
}

export default new ImagesCarouselSections()
